import { FC, memo } from "react"
import { CardType, CurrencyDto, CurrencyType } from "."
import { IOption } from "../../../types"
import { Timer } from "../../common/Timer"
import { CardsItem } from "../CardsItem"
import { CryptoItem } from "../CryptoItem"
import { FlatExchangeSelect } from "../FlatExchangeSelect"
import { SelectorButton } from "../SelectorButton"

type Props = {
  isMobile: boolean
  cardType: CardType
  onCardTypeChange: (cardType: CardType) => void
  onFiatAmountChange: (amount: string) => void
  cryptoOptions: CurrencyType[]
  cryptoCurrency: CurrencyDto | null | undefined
  cryptoAmount: string
  fiatAmount: string
  onUpdate: () => void
  onCryptoAmountChange: (amount: string) => void
  onCryptoCurrencyChange: (option: CurrencyDto) => void
  fiatOptions: CurrencyType[]
  fiatCurrency: CurrencyDto | null | undefined
  onFiatCurrencyChange: (option: CurrencyDto) => void
  onSellClick: () => void
}

const SellBlockComponent: FC<Props> = ({
  isMobile,
  cardType,
  onCardTypeChange,
  cryptoOptions,
  cryptoCurrency,
  cryptoAmount,
  onUpdate,
  fiatAmount,
  onCryptoAmountChange,
  onFiatAmountChange,
  onCryptoCurrencyChange,
  fiatOptions,
  fiatCurrency,
  onFiatCurrencyChange,
  onSellClick,
}) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: isMobile ? "40px" : "80px" }}>
      <div
        style={{
          display: "flex",
          gap: "20px",
          flexDirection: "column",
        }}
      >
        <FlatExchangeSelect
          label={!isMobile ? "You Spend" : undefined}
          buttonTitle={() => <SelectorButton code={cryptoCurrency?.code ?? ""} isOpen name={cryptoCurrency?.name ?? ""} />}
          inputValue={cryptoAmount}
          onChangeInput={(x) => onCryptoAmountChange(x.target.value)}
          // @ts-ignore
          onChange={(x) => onCryptoCurrencyChange(x.meta)}
          options={cryptoOptions}
          dropDownStyle={{ overflowY: "auto" }}
          renderOption={(option: IOption<string, { name: string; rate: number }>, optionProps) => (
            <CryptoItem
              {...optionProps}
              isActive={option.value === cryptoCurrency?.code}
              key={option.value}
              name={option.meta?.name ?? ""}
              currency={option.value}
            />
          )}
        />

        <FlatExchangeSelect
          label={!isMobile ? "You Receive" : undefined}
          buttonTitle={() => (
            <SelectorButton code={fiatCurrency?.code ?? ""} isOpen name={cardType === "1" ? "Debit Card" : "Credit Card"} />
          )}
          inputValue={fiatAmount}
          onChangeInput={(x) => onFiatAmountChange(x.target.value)}
          onChange={() => {}}
          options={[]}
          renderDropDownHeader={({ onClose }) => (
            <CardsItem
              cardType={cardType}
              onCardTypeChange={(type) => {
                onClose()
                onCardTypeChange(type)
              }}
              currencies={fiatOptions}
              currency={fiatCurrency}
              onFiatCurrencyChange={onFiatCurrencyChange}
            />
          )}
          renderOption={() => null}
        />
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: isMobile ? "column" : "row",
          gap: "16px",
          alignItems: "center",
        }}
      >
        <button
          style={{
            border: "none",
            outline: "none",
            color: "#ffffff",
            height: "65px",
            borderRadius: "60px",
            padding: "0 34px",
            backgroundColor: "#E41E1F",
          }}
          onClick={onSellClick}
        >
          Sell {cryptoCurrency?.code ?? ""}
        </button>

        <Timer
          style={{
            lineHeight: "165%",
            fontSize: "16px",
            fontWeight: 500,
            letterSpacing: "-0.16px",
            opacity: 1,
            color: "#818181",
          }}
          withIcon={false}
          count_down={60}
          onUpdate={onUpdate}
          text={"Recalculated in"}
          className={"exchange-form__text_time"}
        />
      </div>
    </div>
  )
}

export const SellBlock = memo(SellBlockComponent)
